<div class="driver-exercise-card">
  <div class="top-card">
    <div class="left-card" (click)="goToRuleGroup()">
      <div class="text">
        <div class="title">
          {{ ruleGroup()?.name }}
          <mat-icon style="color:#2D3872">chevron_right</mat-icon>
        </div>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>

  <div class="bottom-card">
    <div class="child-groups">
      @for(ruleMembership of ruleGroup()?.rule_memberships; track ruleMembership.id) {
      <div class="child-group-item">
        {{ ruleMembership.rule_details.name }}
      </div>
      }
      @if(!ruleGroup()?.rule_memberships || ruleGroup()?.rule_memberships?.length === 0) {
      <div class="no-child-groups">No hay reglas</div>
      }
    </div>
  </div>
</div>
